module.exports = __webpack_public_path__ + "static/img/Taj-Murray.7397216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Taj-Murray.jpg
// module id = hQUt
// module chunks = 0